import { Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';
import { AsyncPipe } from '@angular/common';
import { SplashScreenService } from '../../services/splash-screen/splash-screen.service';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  loadingService = inject(LoaderService);
  splashScreenService = inject(SplashScreenService);

  // Only show loader if splash screen is not active
  loading$ = combineLatest([
    this.loadingService.isLoading,
    this.splashScreenService.isShowing$,
  ]).pipe(map(([isLoading, isSplashShowing]) => isLoading && !isSplashShowing));
}
